<div class="financial-institution-list-content">
  <div *ngIf="formatedGroupList.length; else noGroupList">
    <app-table
      [reorderableColumns]="false"
      [items]="formatedGroupList"
      [columnDefinitions]="columnDefinitions"
      [getOptionsFunction]="getMenuActions.bind(this)"
      [permissions]="financialInstitutionPermissions"
      [totalRecords]="pagination.total"
      [rows]="pagination.itemsPerPage || 5"
      (sendTablePagination)="handleTablePagination($event)"
      (sendTableAction)="handleTableAction($event)">
      <ng-template appNamedTemplate="logo" let-item>
        <app-bank-logo [institution]="item" />
      </ng-template>
    </app-table>
  </div>
  <ng-template #noGroupList>
    <div class="financial-institution-list-content__empty mt-7">
      <h4>{{ tk.Management.NoFinancialInstitutionsRegistered | t }}</h4>

      <div
        class="financial-institution-list-content__empty__button"
        *appHasPermission="financialInstitutionPermissions.CREATE">
        <app-button
          [id]="'add-group'"
          [label]="tk.User.ToAdd | t"
          [icon]="'pi pi-plus'"
          [type]="'button'"
          (sendButtonClick)="addFinancialInstitution()"></app-button>
      </div>
    </div>
  </ng-template>
</div>
